import { BlockCompletionProvider } from "@pathwright/blocks-engine"
import View from "@pathwright/ui/src/components/ui/View"
import React from "react"
import styled from "styled-components"
import { getBlock } from "../../block/utils"

const size = {
  width: 180,
  height: 120
}

const previewWidth = 700

const previewSize = {
  width: previewWidth,
  height: (size.height / size.width) * previewWidth,
  scale: size.width / previewWidth
}

const PreviewWrap = styled.div`
  position: relative;
  overflow: hidden;
  width: ${size.width}px;
  border-radius: 4px;
  height: ${size.height}px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
`

const PreviewInner = styled(View.Primary)`
  position: absolute;
  left: 0px;
  top: 0px;
  width: ${previewSize.width}px;
  height: ${previewSize.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: 0 0;
  transform: scale(${previewSize.scale});
  pointer-events: none; // prevent block interaction

  .VideoWrapperView {
    height: 100%;

    .VideoWrapper {
      max-height: 100%;
      height: 100%;
    }
    .VideoWrapper > .TheVideo {
      height: 100%;
    }
  }

  .AnnotatedAssessmentView {
    width: 70%;
  }
`

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const BlockLayoutPreview = (props) => {
  const { type, data, completion, previewImage } = props

  const BlockViewComponent = React.useMemo(() => getBlock(type, "view"), [type])

  return (
    <BlockCompletionProvider completion={completion} data={data}>
      <PreviewWrap className="BlockPreviewWrap">
        <PreviewInner tabIndex="-1">
          {previewImage ? (
            <PreviewImage src={previewImage} />
          ) : (
            <BlockViewComponent {...props} preview={true} />
          )}
        </PreviewInner>
      </PreviewWrap>
    </BlockCompletionProvider>
  )
}

export default BlockLayoutPreview
